import React from 'react';
import { Heart, ArrowUp, Github, Linkedin, Mail } from 'lucide-react';
import { profileData, navLinks } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                scrollToTop();
              }}
              className="text-2xl font-light tracking-tight hover:text-gray-300 transition-colors duration-300"
              style={{ fontFamily: 'Figtree, sans-serif' }}
            >
              {profileData.name.split(' ')[0]}
              <span className="text-gray-500">.</span>
            </a>
            <p
              className="text-gray-400 mt-4 text-sm leading-relaxed"
              style={{ fontFamily: 'Figtree, sans-serif' }}
            >
              Software Engineer crafting digital experiences with the MERN stack.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-sm uppercase tracking-widest text-gray-500 mb-4"
              style={{ fontFamily: 'Figtree, sans-serif' }}
            >
              Quick Links
            </h4>
            <nav className="space-y-2">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="block text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                  style={{ fontFamily: 'Figtree, sans-serif' }}
                >
                  {link.name}
                </button>
              ))}
            </nav>
          </div>

          {/* Social & Contact */}
          <div>
            <h4
              className="text-sm uppercase tracking-widest text-gray-500 mb-4"
              style={{ fontFamily: 'Figtree, sans-serif' }}
            >
              Connect
            </h4>
            <div className="flex gap-4 mb-6">
              <a
                href={profileData.github}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-all duration-300 hover:scale-110"
              >
                <Github size={18} />
              </a>
              <a
                href={profileData.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-all duration-300 hover:scale-110"
              >
                <Linkedin size={18} />
              </a>
              <a
                href={`mailto:${profileData.email}`}
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-all duration-300 hover:scale-110"
              >
                <Mail size={18} />
              </a>
            </div>
            <p
              className="text-gray-400 text-sm"
              style={{ fontFamily: 'Figtree, sans-serif' }}
            >
              {profileData.email}
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p
              className="text-gray-500 text-sm flex items-center gap-1"
              style={{ fontFamily: 'Figtree, sans-serif' }}
            >
              © {new Date().getFullYear()} {profileData.name}. Built with
              <Heart size={14} className="text-red-500 fill-red-500" />
            </p>
            
            {/* Back to Top */}
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2 text-gray-500 hover:text-white transition-colors duration-300 text-sm"
              style={{ fontFamily: 'Figtree, sans-serif' }}
            >
              Back to top
              <ArrowUp size={16} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
